// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page__QuotePage-module--wLfJ_ {
    max-width: 1200px;
    margin: 0 auto;
    padding: var(--space-2xl) var(--space-md) var(--space-3xl);
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(min(420px, 100%), 1fr));
    gap: var(--space-2xl);
    align-items: start;
}

.intro__QuotePage-module--qF8vK {
    display: flex;
    flex-direction: column;
    gap: var(--space-md);
    min-width: 0;
}

.heading__QuotePage-module--HWEpK {
    margin: 0 0 var(--space-xs);
    font-size: var(--home-text-heading);
    font-weight: 800;
    letter-spacing: -0.02em;
    line-height: 1;
    text-wrap: balance;
}

.paragraph__QuotePage-module--tzwOz {
    margin: 0;
    max-width: 60ch;
    font-size: 17px;
    line-height: 1.65;
    color: var(--color-text-secondary);
}

.card__QuotePage-module--vDRjd {
    min-width: 0;
    padding: var(--space-lg);
    border-radius: var(--home-radius-3xl);
    background: var(--color-surface-secondary);
}

.alert__QuotePage-module--dX9S5 {
    margin-bottom: var(--space-md);
}
`, "",{"version":3,"sources":["webpack://./src/main/ui/home/QuotePage.module.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,cAAc;IACd,0DAA0D;IAC1D,aAAa;IACb,sEAAsE;IACtE,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,YAAY;AAChB;;AAEA;IACI,2BAA2B;IAC3B,mCAAmC;IACnC,gBAAgB;IAChB,uBAAuB;IACvB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,kCAAkC;AACtC;;AAEA;IACI,YAAY;IACZ,wBAAwB;IACxB,qCAAqC;IACrC,0CAA0C;AAC9C;;AAEA;IACI,8BAA8B;AAClC","sourcesContent":[".page {\n    max-width: 1200px;\n    margin: 0 auto;\n    padding: var(--space-2xl) var(--space-md) var(--space-3xl);\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(min(420px, 100%), 1fr));\n    gap: var(--space-2xl);\n    align-items: start;\n}\n\n.intro {\n    display: flex;\n    flex-direction: column;\n    gap: var(--space-md);\n    min-width: 0;\n}\n\n.heading {\n    margin: 0 0 var(--space-xs);\n    font-size: var(--home-text-heading);\n    font-weight: 800;\n    letter-spacing: -0.02em;\n    line-height: 1;\n    text-wrap: balance;\n}\n\n.paragraph {\n    margin: 0;\n    max-width: 60ch;\n    font-size: 17px;\n    line-height: 1.65;\n    color: var(--color-text-secondary);\n}\n\n.card {\n    min-width: 0;\n    padding: var(--space-lg);\n    border-radius: var(--home-radius-3xl);\n    background: var(--color-surface-secondary);\n}\n\n.alert {\n    margin-bottom: var(--space-md);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `page__QuotePage-module--wLfJ_`,
	"intro": `intro__QuotePage-module--qF8vK`,
	"heading": `heading__QuotePage-module--HWEpK`,
	"paragraph": `paragraph__QuotePage-module--tzwOz`,
	"card": `card__QuotePage-module--vDRjd`,
	"alert": `alert__QuotePage-module--dX9S5`
};
export default ___CSS_LOADER_EXPORT___;
